export default __webpack_public_path__ + "static/media/Pro-4.da108286.png";